const portfolio = [
  {
    img: "https://images.unsplash.com/photo-1587202372775-e229f172b9d7?auto=format&fit=crop&w=900&q=80",
    title: "RGB Performance",
    tag: "Build #014 · 4K Gaming",
    specs: "RTX 4080 · i7-14700K · 32 Go DDR5",
  },
  {
    img: "https://static.prod-images.emergentagent.com/jobs/66b23153-6ac2-423a-b425-4af124f4013d/images/f499875bf6eec3ae67f64e75504be88f00a344d634296d401414441a001909d4.png",
    title: "Stealth Matte Black",
    tag: "Build #022 · Streaming",
    specs: "RTX 4070 Super · Ryzen 7 · NVMe 2 To",
  },
  {
    img: "https://images.unsplash.com/photo-1591488320449-011701bb6704?auto=format&fit=crop&w=900&q=80",
    title: "Neon RAM Build",
    tag: "Build #031 · 1440p compétitif",
    specs: "RTX 4070 · i5-14600K · 32 Go DDR5 6000",
  },
  {
    img: "https://static.prod-images.emergentagent.com/jobs/66b23153-6ac2-423a-b425-4af124f4013d/images/6dae7bf938aa171f9b4dff5a8f03407f5b0bda6e47a9ea6cc794dd37ea72ad50.png",
    title: "Atelier ZF",
    tag: "Coulisses",
    specs: "Là où la magie opère.",
  },
];

export default function Portfolio() {
  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="relative py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between gap-6 flex-wrap reveal">
          <div className="max-w-2xl">
            <p className="font-mono text-xs uppercase tracking-[0.22em] text-violet-400">
              // Réalisations
            </p>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
              Des builds qui parlent d'eux-mêmes.
            </h2>
          </div>
          <p className="text-sm text-zinc-500 max-w-sm">
            Chaque PC est testé, photographié et livré dans un emballage soigné.
            Quelques exemples récents.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {portfolio.map((b, i) => (
            <article
              key={b.title}
              data-testid={`portfolio-item-${i}`}
              className="reveal group relative overflow-hidden rounded-2xl border border-white/10 bg-zinc-900/40 hover:border-violet-400/40 transition-all"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={b.img}
                  alt={b.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-5">
                <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-violet-300">
                  {b.tag}
                </p>
                <h3 className="mt-1.5 font-display text-lg font-semibold text-white">
                  {b.title}
                </h3>
                <p className="mt-1 text-xs text-zinc-300/90">{b.specs}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
